var map = {
	"./pcBlack/introduceIcon1-3.png": 1780,
	"./pcBlack/introduceIcon2-3.png": 5949,
	"./pcBlack/introduceIcon3-3.png": 8853,
	"./pcBlack/introduceIcon4-3.png": 8191
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 329;